type TPercentAxisWire = {
  x_axis_data?: string[];
  series_data?: unknown[];
} | null | undefined;

/** 将 percent_line_chart / percent_stack_bar_chart wire 转为图表组件 chartData 形态 */
export function mapPercentAxisWireToChartData(wire: TPercentAxisWire): {
  xAxisData: string[];
  seriesData: unknown[];
} {
  return {
    xAxisData: wire?.x_axis_data ?? [],
    seriesData: wire?.series_data ?? [],
  };
}
